/**
 * Language: Turkish.
 */
export default {
    time: {
        openingHoursTitle: "Çalışma saatleri",
        at: "",
     	to: "–",
        opensToday: "Bugün açılıyor:",
        opens: "Açılır:",
        open24_7: "7/24 açık",
        closed: "Kapalı",
        openUntil: "Şu saate kadar açık",
        daily: "Günlük",
        month: [
            'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
            'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'
        ],
        monthAbbr: [
            'Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz',
            'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'
        ],
        dayOfWeek: [
            'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi','Pazar', 
        ],
        dayOfWeekAbbr: [
            'Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt','Paz', 
        ],
        temporarilyClosed: "Geçici olarak kapalı",
        opened: "",
        today: ""
    },
    search: {
        placeholder: "Sokak, şehir veya posta kodu",
        submitLabel: "Ara",
        clearLabel: "Aramayı temizle",
        yourLocation: "Konumun",
    },
    filtering: {
        servicesTitle: "Hizmetler",
        services: {
            WF: 'Kablosuz İnternet Noktası',
            CD: 'Mobil Ödeme',
            DT: 'Drive-Thru',
            DR: 'Dijital Ödüller',
            hrs24: 'Günün 24 saati açık',
            WA: 'Fırında Isıtılmış Yiyecek',
            LB: 'LaBoulange',
            XO: 'Mobil Sipariş ve Ödeme',
            VS: 'Verismo',
            NB: 'Nitro Soğuk Kahve',
            CL: 'Starbucks Reserve-Clover Demlenmiş',
        }
    },
    stores: {
        cta: {
            call: "Ara",
            directions: "Yol Tarifi",
            website: "Web Sitesi",
            'club details': 'Kulüp detayları',
            'view tariffs': 'BİZE KATIL',
            'View Map': "Haritayı görüntüle",
            'View List': "Listeyi görüntüle"
        },
        messages: {
            initialHeader: "Yakındaki kulüpleri göstermek için bir bölge arayarak başla",
            emptyHeader: "Hiçbir kulüp bulunamadı",
            initialBody: "veya haritada bir kulüp seçmek için tıkla",
            emptyBody: "Lütfen farklı bir bölge ara veya filtreleri kaldır"
        }
    },
    directions: {
        avoidOptions: {
            highways: 'Otoyollar',
            tolls: 'Geçiş ücretleri',
            ferries: 'Feribotlar'
        },
        unitOptions: {
            METRIC: 'km',
            IMPERIAL: 'mil'
        },
        options: "Rota seçenekleri",
        avoid: "Kaçın",
        units: "Uzaklık birimleri",
        messages: {
            initialBody: "Mevcut rotaları ve seyahat sürelerini görmek için bir başlangıç ve varış noktası arayın.",
            error: "Üzgünüz, sürüş yönergeleri hesaplanamadı",
            from: "kaynak",
            to: "hedef",
            forTravelMode: "seyahat türü için",
            via: "üzerinden",
            details: "Detaylar",
            withoutTraffic: "trafiksiz",
            openGoogleMaps: "Google Haritalar'da aç"
        }
    },
    errors: {
        loadingLibrary: "{library} betiği yüklenemedi",
        geolocationFailed: "Kullanıcı konumu belirleme başarısız",
        apiErrors:{
            "401": "Yetkisiz",
            "403": "Yasak",
            "429": "Çok fazla istek",
            "500": "Dahili sunucu hatası",
            other: "Beklenmeyen bir sunucu hatası oluştu"
        }
    },
};
